import { render, staticRenderFns } from "./AM3OptinPanel.vue?vue&type=template&id=15aa9608&scoped=true"
import script from "./AM3OptinPanel.vue?vue&type=script&lang=js"
export * from "./AM3OptinPanel.vue?vue&type=script&lang=js"
import style0 from "./AM3OptinPanel.vue?vue&type=style&index=0&id=15aa9608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa9608",
  null
  
)

export default component.exports